import getCommonDataBank from '@/router/middleware/getCommonDataBank';
import getApps from '@/router/middleware/getApps';
import getApp from '@/router/middleware/getApp';
import getSysParameters from '@/router/middleware/getSysParameters';
import getSounds from '@/router/middleware/getSounds';
import loaderStart from '@/router/middleware/loaderStart';
import loaderStop from '@/router/middleware/loaderStop';
export default {
  name: 'bank',
  path: '/bank',
  component: () => import(/* webpackChunkName: "bank" */ '@/views/bank/index.vue'),
  children: [
    {
      name: 'clients',
      path: 'clients',
      component: () => import(/* webpackChunkName: "clients" */ '@/views/bank/clients/ClientsView.vue'),
      props: true,
    },
    {
      path: 'applications',
      name: 'applications',
      component: () => import(/* webpackChunkName: "applications" */ '@/views/bank/Applications/Applications.vue'),
      meta: {
        middleware: [loaderStart, getCommonDataBank, getApps, getSounds, loaderStop],
      },
    },
    {
      path: 'application/:id',
      name: 'application',
      component: () => import('@/views/bank/Application.vue'),
      props: true,
      meta: {
        middleware: [loaderStart, getCommonDataBank, getApp, getSysParameters, getSounds, loaderStop],
      },
    },
    {
      name: 'pending-list',
      path: 'pending-list',
      component: () => import(/* webpackChunkName: "clients" */ '@/views/bank/pendingList/PendingListView.vue'),
      props: true,
    },
  ],
};
